import { render, staticRenderFns } from "./ModifyScorePopup.vue?vue&type=template&id=3bd982cb"
import script from "./ModifyScorePopup.vue?vue&type=script&lang=js"
export * from "./ModifyScorePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports